import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: 'https://api.lizepuppet.com.tw', // api的base_url
  timeout: 5000 // request timeout
})

// respone interceptor
service.interceptors.response.use(
  response => response,
  error => {
    console.log('err' + error)// for debug
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js